import { RunContextApp }            from './framework/RCApp';
import { Provider }                 from 'react-redux';
import store                        from 'store/Store';
import { AppRoutes }                from 'routes/AppRoutes';
import { BrowserRouter as Router, 
      }                             from 'react-router';
import { GlobalConfigProvider }     from 'context/GlobalContext';
import { ToastProvider }            from 'context/ToastContext';
import { ThemeProvider as CustomThemeProvider 
       }                            from 'context/ThemeContext';
import './App.css';

interface AppProps {
  rc : RunContextApp
}

function App(props : AppProps) {

  props.rc.session.setStore(store)

  return (
    <GlobalConfigProvider rc={props.rc}>
      <CustomThemeProvider>
        <ToastProvider>
          <div className="App">
            <Provider store={store}>
              <Router>
                <AppRoutes/>
              </Router>
            </Provider>
          </div>
        </ToastProvider>
      </CustomThemeProvider>
    </GlobalConfigProvider>
  );
}

export default App;
